import { render } from "./BasketWidgetComponent.vue?vue&type=template&id=858fad7c&ts=true"
import script from "./BasketWidgetComponent?vue&type=script&lang=ts"
export * from "./BasketWidgetComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__